import { render } from "./Attention.vue?vue&type=template&id=300c4207&scoped=true"
import script from "./Attention.vue?vue&type=script&lang=js"
export * from "./Attention.vue?vue&type=script&lang=js"

import "./Attention.vue?vue&type=style&index=0&id=300c4207&lang=scss"
import "./Attention.vue?vue&type=style&index=1&id=300c4207&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300c4207"]])

export default __exports__